export const SET_IS_OPEN = 'SET_IS_OPEN'
export const SET_SELECTED_DOCUMENTS = 'SET_SELECTED_DOCUMENTS'
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
export const RESET_SELECTED_DOCUMENTS = 'RESET_SELECTED_DOCUMENTS'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_DOWNLOAD_PENDING = 'SET_DOWNLOAD_PENDING'
export const SET_DOWNLOAD_ERROR = 'SET_DOWNLOAD_ERROR'
